export enum Validation {
    Success = 'ValidationSuccess',
    Error = 'ValidationError',
    InvalidFieldValue = 'InvalidFieldValue',
    Valid = 'Valid'    
}
